<script setup lang="ts">
import Card from 'primevue/card';
import Message from 'primevue/message';
import KpButton from '@/components/KpButton.vue';
import InputOtp from 'primevue/inputotp';
import Image from 'primevue/image';
import Skeleton from 'primevue/skeleton';
import { ref } from 'vue';

defineProps({
    qrCode: {
        type: String,
        default: '',
    },
    totpSecret: {
        type: String,
        default: '',
    },
    footerText: {
        type: String,
        default: '',
    },
    error: {
        type: String,
        default: '',
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

const totpCode = ref('');

defineEmits(['verifyCode']);
</script>

<template>
    <Card class="mt-5rem" style="width: 25rem; overflow: hidden; margin-left: auto; margin-right: auto">
        <template #title>ECO<sub>2</sub>Stat: {{ $t('anmelden') }}</template>
        <template #content>
            <div>{{ $t('totp_qr_code_nachricht') }}</div>
            <div style="text-align: center">
                <Image v-if="qrCode" :src="qrCode" alt="QR-Code" width="256" />
                <Skeleton v-else class="my-1rem" style="justify-self: center" size="14rem"></Skeleton>
            </div>
            <div>{{ $t('totp_secret_nachricht') }}</div>
            <div v-if="totpSecret" class="my-1rem" style="font-weight: bold; text-align: center">{{ totpSecret }}</div>
            <Skeleton v-else class="my-1rem mb-2"></Skeleton>
            <div>
                <div class="my-1rem">{{ $t('totp_code_eingeben') }}</div>
                <InputOtp
                    style="justify-content: space-between"
                    integerOnly
                    :length="6"
                    v-model="totpCode"
                    size="large"
                    @keydown="(event: KeyboardEvent) => (event.key === 'Enter' ? $emit('verifyCode', totpCode) : null)"
                ></InputOtp>
            </div>
        </template>
        <template #footer>
            <div class="flex gap-4 mt-1">
                <KpButton
                    :disabled="totpCode.length !== 6"
                    :label="$t('pruefen')"
                    class="w-full"
                    icon="far fa-right-to-bracket"
                    iconPos="right"
                    :loading="loading"
                    @click="$emit('verifyCode', totpCode)"
                />
            </div>
            <Message v-if="error" severity="error" class="w-full my-1rem">{{ error }}</Message>
            <div class="w-full mt-2rem text-center" v-html="footerText"></div>
        </template>
    </Card>
</template>
